<!-- <div><i><small>This is from the multiple answer question component</small></i></div> -->
<div class="mb-4 quiz-multiple-choice-checkboxes" >
  @for (option of question.options; track option) {
    <div>
      <label class="custom-input">
        <span [innerHTML]="option.text"></span>
        @if (showFeedback && option.isCorrect) {
          <span class="icon-gecko-check text-success ml-1"></span>
        }
        @if (showFeedback && option.isSelected && !option.isCorrect) {
          <span class="icon-gecko-delete text-warning ml-1"></span>
        }
        <input (change)="checkboxChanged()" type="checkbox" checked="" [disabled]="showFeedback || isOffline" [(ngModel)]="option.isSelected" name="optcheck">
        <span class="checkmark"></span>
        @if (showFeedback && option.isSelected && option.isCorrect) {
          <span class="text-info small" [innerHTML]="option.commentsHtml"></span>
        }
      </label>
    </div>
  }

  @if (showFeedback && answerIsCorrect() && question.correctCommentsHtml!=null) {
    <div ebsTechnicalContent id="correctComments" class="text-info small" [innerContent]="question.correctCommentsHtml"></div>
  }
  @if (showFeedback && !answerIsCorrect() && question.incorrectCommentsHtml!=null) {
    <div ebsTechnicalContent id="incorrectComments" class="text-info small" [innerContent]="question.incorrectCommentsHtml"></div>
  }
  @if (showFeedback && question.neutralCommentsHtml!=null) {
    <div ebsTechnicalContent id="neutralComments" class="text-info small" [innerContent]="question.neutralCommentsHtml"></div>
  }
</div>
